export const campos = [
  {
    headerName: 'Número de Configuración',
    field: 'numeroconfig',
    minwidth: 100,
    width: 200,
  },
  {
    headerName: 'Usuario',
    field: 'usuariocompleto',
    width: 400,
  },
  {
    headerName: 'ID',
    field: 'usuarioid',
    hide: true,
  },

  {
    headerName: 'Número de Orden',
    field: 'numeroorden',
  },
  {
    headerName: 'Operación',
    field: 'configdescripcion',
  },
  {
    headerName: 'Observación',
    field: 'autoobserva',
    width: 500,
  },
  {
    headerName: 'Estado',
    field: 'estado',
    width: 150,
    cellRenderer: (params: any) => {
      return `<i class="material-icons" style="width: 15px; height: 15px;margin-top: 7px; border-radius: 50%; background: ${
        params.data.estado == 'ACTIVO' ? 'rgb(42, 255, 78)' : 'rgb(255, 58, 58)'
      } " ></i>
      <a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">${
        params.data.estado
      }</a>`;
    },
  },
];
